import Poptip from './poptip';
export default Poptip;
